import { render, staticRenderFns } from "./ViewProfilePage.vue?vue&type=template&id=6c37cb14"
import script from "./ViewProfilePage.vue?vue&type=script&lang=js"
export * from "./ViewProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports